import { ErrorOutlineRounded } from '@material-ui/icons';

import { useSubstitutionFlowStatusAlert } from './hooks';

import makeClasses from './SubstitutionFlowStatusAlert.style';

import type { OrderId } from 'shared/domain';

export function SubstitutionFlowStatusAlert(props: Props) {
  const { orderId } = props;

  const { lang, isRendered } = useSubstitutionFlowStatusAlert({ orderId });

  const _classes = makeClasses();

  if (!isRendered) return null;
  return (
    <aside role='alert' aria-live='polite' className={_classes.alert}>
      <ErrorOutlineRounded className={_classes.icon} />
      <p className={_classes.message}>
        <strong>{lang.strong}</strong>&nbsp;
        <span dangerouslySetInnerHTML={{ __html: lang.sentence }} />
      </p>
    </aside>
  );
}

interface Props {
  orderId: OrderId;
}
